import { useState } from "react";
import useRead from "./useRead";
import useCreate from "./useCreate";
import toast from "react-hot-toast";

const useThresholdSettings = () => {
  const [b2bRows, setB2bRows] = useState([]);
  const [b2cRows, setB2cRows] = useState([]);
  const [b2bStatus, setB2bStatus] = useState(true);
  const [b2cStatus, setB2cStatus] = useState(true);
  const [editingId, setEditingId] = useState(null);
  const [savingId, setSavingId] = useState(null);

  const { data: thresholdData } = useRead({
    url: "list_cart_threshold",
    initialData: {},
    method: "GET",
    onSuccess: (data) => {
      setB2bRows(data?.b2b_data || []);
      setB2cRows(data?.b2c_data || []);
      setB2bStatus(data?.b2b_status === true || data?.b2b_status === "1" || data?.b2b_status === 1);
      setB2cStatus(data?.b2c_status === true || data?.b2c_status === "1" || data?.b2c_status === 1);
      setEditingId(null);
      setSavingId(null);
    },
  });

  const { setDataToServer: createUpdateThreshold } = useCreate({
    url: "add_update_cart_threshold",
    refreshUrl: "list_cart_threshold",
    onSuccess: (data, reqParams) => {
      const action = reqParams.cart_threshold_id ? "Updated" : "Created";
      toast.success(`Threshold ${action} Successfully`, {
        position: "top-right",
        duration: 3000,
      });
      setEditingId(null);
      setSavingId(null);
    },
    onError: (err) => {
      const errorMessage = err?.response?.data?.message || "Failed to Save Threshold";
      toast.error(errorMessage, {
        position: "top-right",
        duration: 3000,
      });
      setSavingId(null);
    },
  });

  const { setDataToServer: deleteThreshold } = useCreate({
    url: "delete_cart_threshold",
    refreshUrl: "list_cart_threshold",
    onSuccess: () => {
      toast.success("Threshold Deleted Successfully", {
        position: "top-right",
        duration: 3000,
      });
    },
    onError: (err) => {
      const errorMessage = err?.response?.data?.message || "Failed to Delete Threshold";
      toast.error(errorMessage, {
        position: "top-right",
        duration: 3000,
      });
    },
  });

  const { setDataToServer: updateThresholdStatus } = useCreate({
    url: "update_cart_threshold_status",
    refreshUrl: "list_cart_threshold",
    onSuccess: (data, reqParams) => {
      toast.success("Threshold Status Updated Successfully", {
        position: "top-right",
        duration: 3000,
      });
    },
    onError: (err) => {
      const errorMessage = err?.response?.data?.message || "Failed to Update Threshold Status";
      toast.error(errorMessage, {
        position: "top-right",
        duration: 3000,
      });
    },
  });

  const { setDataToServer: updateSettingsTypeStatus } = useCreate({
    url: "update_cart_settings_type_status",
    refreshUrl: "list_cart_threshold",
    onSuccess: (data, reqParams) => {
      toast.success("Settings Type Status Updated Successfully", {
        position: "top-right",
        duration: 3000,
      });
    },
    onError: (err) => {
      const errorMessage = err?.response?.data?.message || "Failed to Update Settings Type Status";
      toast.error(errorMessage, {
        position: "top-right",
        duration: 3000,
      });
    },
  });

  const addRow = (type) => {
    const newRow = {
      cart_threshold_id: null,
      cart_settings_type: type,
      threshold: "",
      cart_threshold_value: "",
    };
    if (type === "B2B") {
      setB2bRows([...b2bRows, newRow]);
    } else {
      setB2cRows([...b2cRows, newRow]);
    }
  };

  const updateRowField = (type, index, field, value) => {
    if (type === "B2B") {
      const updatedRows = [...b2bRows];
      updatedRows[index][field] = value;
      setB2bRows(updatedRows);
    } else {
      const updatedRows = [...b2cRows];
      updatedRows[index][field] = value;
      setB2cRows(updatedRows);
    }
  };

  const saveThreshold = (type, index) => {
    const rows = type === "B2B" ? b2bRows : b2cRows;
    const row = rows[index];
    const payload = {
      cart_threshold_value: row.cart_threshold_value,
      threshold: row.threshold,
      cart_settings_type: type,
    };

    if (row.cart_threshold_id) {
      payload.cart_threshold_id = row.cart_threshold_id;
    }

    setSavingId(row.cart_threshold_id || `temp-${index}`);
    createUpdateThreshold.mutate(payload);
  };

  // Remove unsaved row if cancel is clicked on a new row
  const cancelEditRow = (type, index) => {
    if (type === "B2B") {
      const updatedRows = [...b2bRows];
      if (updatedRows[index].cart_threshold_id == null) {
        updatedRows.splice(index, 1);
        setB2bRows(updatedRows);
      }
    } else {
      const updatedRows = [...b2cRows];
      if (updatedRows[index].cart_threshold_id == null) {
        updatedRows.splice(index, 1);
        setB2cRows(updatedRows);
      }
    }
    setEditingId(null);
  };

  return {
    thresholdData,
    b2bRows,
    b2cRows,
    b2bStatus,
    b2cStatus,
    editingId,
    setEditingId,
    savingId,
    setSavingId,
    addRow,
    updateRowField,
    saveThreshold,
    cancelEditRow,
    deleteThreshold: deleteThreshold.mutate,
    updateThresholdStatus: updateThresholdStatus.mutate,
    updateSettingsTypeStatus: updateSettingsTypeStatus.mutate,
    isLoading: thresholdData.isLoading,
    isFetching: thresholdData.isFetching,
  };
};

export default useThresholdSettings;
